import G6, { TreeGraph } from '@antv/g6/dist/g6.min';
import {
  rightsOperationsOptionsKeyMap,
  rightsOperationsOptionsMap,
  rightsOperationsTimesOptionsKeyMap,
  rightsOperationsTimesOptionsMap
} from '../options';
import { generateActionBar } from './common';
import {
  conditionContentPaddingY,
  conditionRowHeight,
  conditionRowInnerHeight,
  conditionTitleHeight,
  CustomNodeType
} from './config';

function changeEvtfn(e) {
  const target = e.target;
  // 第一列
  if (target.classList.contains('rightsinfo-col-1-select')) {
    const id = target.getAttribute('data-id');

    // @ts-ignore
    window.onRightsInfoCol1Change(id, e.target);
  }
  // 第二列
  else if (target.classList.contains('rightsinfo-col-2-select')) {
    const id = target.getAttribute('data-id');

    // @ts-ignore
    window.onRightsInfoCol2Change(id, e.target);
  }
}

function inputEvtfn(e) {
  const target = e.target;

  // 数值
  if (target.classList.contains('rightsinfo-num-input')) {
    const id = target.getAttribute('data-id');

    // @ts-ignore
    window.onRightsInfoNumInput(id, e.target);
  }
}

function blurEvtfn(e) {
  const target = e.target;
  // 数值
  if (target.classList.contains('rightsinfo-num-input')) {
    const id = target.getAttribute('data-id');
    // @ts-ignore
    window.onRightsInfoNumBlur(id, e.target);
  }
}
const activityTypeHTML = {
  DIRECT_DESCENT: '<span style="font-size:14px;color:#333;">按关联商品清单特价价格/特价扣率执行</span>'
};
export const registerRightsInfoShape = (rowData) => {
  G6.registerNode(CustomNodeType.RIGHTS_INFO, {
    draw: (cfg, group) => {
      const jsonData = rowData[cfg.dataId];
      const conditionHtml = `
      <div style="display: flex;align-items: center;column-gap: 4px;height: ${conditionRowHeight}px">
      ${
        activityTypeHTML[`${(cfg as any).activityType}`]
          ? activityTypeHTML[`${(cfg as any).activityType}`]
          : `<select data-id="${
              cfg!.id
            }" class="rightsinfo-col-1-select condition-select" style="height: ${conditionRowInnerHeight}px;" placeholder="">
        ${rightsOperationsOptionsMap[(cfg as any).activityType].reduce(
          (t, c) =>
            t +
            `<option value="${c.value}" ${
              jsonData?.equityInformationRule?.[rightsOperationsOptionsKeyMap[(cfg as any).activityType]] == c.value
                ? 'selected'
                : ''
            } ${(cfg!.col1DisabledOptions as string[]).includes(c.value) ? 'disabled' : ''}>${c.label}</option>`,
          ''
        )}
        </select>
        ${
          ((cfg as any).activityType === 'FULL_SUB' &&
            jsonData?.equityInformationRule?.reductionOption === 'DISCOUNT_RATE') ||
          (cfg as any).activityType === 'SECKILL'
            ? ''
            : `<select data-id="${
                cfg!.id
              }" class="rightsinfo-col-2-select condition-select" style="height: ${conditionRowInnerHeight}px;" placeholder="">
        ${rightsOperationsTimesOptionsMap[(cfg as any).activityType].reduce(
          (t, c) =>
            t +
            `<option value="${c.value}" ${
              jsonData?.equityInformationRule?.[rightsOperationsTimesOptionsKeyMap[(cfg as any).activityType]] ==
              c.value
                ? 'selected'
                : ''
            }>${c.label}</option>`,
          ''
        )}
        </select>`
        }
      ${
        (cfg as any).activityType === 'SECKILL'
          ? ''
          : `
        <input id="rights_${cfg!.id}" data-id="${cfg!.id}" class="rightsinfo-num-input condition-number-input" value="${
              jsonData?.equityInformationRule?.discountValue ?? ''
            }" placeholder="数值" style="width: 50px;height: ${conditionRowInnerHeight}px;"/>
        `
        }`
      }
      </div>
    `;

      // 只监听一次事件
      document.body.removeEventListener('change', changeEvtfn);
      document.body.removeEventListener('input', inputEvtfn);
      document.body.removeEventListener('blur', blurEvtfn, true);
      document.body.addEventListener('change', changeEvtfn);
      document.body.addEventListener('input', inputEvtfn);
      document.body.addEventListener('blur', blurEvtfn, true);

      return group!.addShape('dom', {
        attrs: {
          width: cfg!.size![0],
          height: cfg!.size![1],
          // 传入 DOM 的 html
          html: `
          <div>
            <div style="background-color: #f2f2f2;border-radius:4px;height: 100%;">
              <div style="background-color: ${
                cfg!.style!.titleBgColor
              }; color: #fff; font-size: 12px;text-align: center;border-radius:4px;height: ${conditionTitleHeight}px;line-height: ${conditionTitleHeight}px;">
              权益信息
              </div>
              <div style="padding: ${conditionContentPaddingY}px ${conditionContentPaddingY * 2}px;">
                <div style="display: flex;">
                  ${conditionHtml}
                </div>
              </div>
            </div>
            ${generateActionBar({ ...jsonData, ...cfg })}
          </div>
        `
        }
      });
    }
  });
};
